<template>
	<svg viewBox="0 0 52 46" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M27.5507 1C26.7809 -0.333333 24.8564 -0.333333 24.0866 1L0.270933 42.25C-0.498867 43.5833 0.463383 45.25 2.00298 45.25H49.6344C51.174 45.25 52.1362 43.5833 51.3664 42.25L27.5507 1ZM28.1197 24.484V18.52H23.1637V24.484L23.6957 30.98H27.5877L28.1197 24.484ZM27.6157 33.164C27.1304 32.7533 26.4677 32.548 25.6277 32.548C24.7877 32.548 24.1251 32.7533 23.6397 33.164C23.1731 33.5747 22.9397 34.1533 22.9397 34.9C22.9397 35.628 23.1731 36.1973 23.6397 36.608C24.1251 37.0187 24.7877 37.224 25.6277 37.224C26.4677 37.224 27.1304 37.0187 27.6157 36.608C28.1011 36.1973 28.3437 35.628 28.3437 34.9C28.3437 34.1533 28.1011 33.5747 27.6157 33.164Z" fill="#D15756"/>
	</svg>
</template>

<script>
export default {
  name : 'icon-alert'
};
</script>
